import { HttpErrorResponse } from '@angular/common/http';
import { isServerErrorResponse, ServerErrorResponse } from './model';

export function getServerError(errorResponse: HttpErrorResponse): ServerErrorResponse {
  if (isServerErrorResponse(errorResponse.error)) {
    return errorResponse.error;
  }

  return {
    status: errorResponse.status,
    message: getHttpError(errorResponse),
    errors: [],
  };
}

function getHttpError(errorResponse: HttpErrorResponse) {
  if (!errorResponse.error) {
    return errorResponse.message;
  }

  if (errorResponse.error instanceof Error) {
    return errorResponse.error.message;
  }

  if (typeof errorResponse.error === 'object') {
    return JSON.stringify(errorResponse.error);
  }

  return errorResponse.error;
}
